import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearch } from "../../../actions/Ticket";
export const SearchBarMobile = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank); //dataSearchTaiSan dinh nghia o rootreducer

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };
  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      id="iconLeft1"
                      placeholder="Tiêu đề"
                      value={dataSearch.tieude}
                      onChange={updateTextValue("tieude")}
                    />
                    <div className="form-control-position" >
                      <button type="button" onClick={onSearch} className="btn btn-info-new">
                        <i className="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
